import { observer } from 'mobx-react';
import { Navigate, Outlet } from 'react-router-dom';
import { useFlag } from 'hooks/useFlag';
import { useStore } from 'hooks/useStore';

interface FlaggedRouteProps {
  flagKey: string;
  redirectTo?: string;
}

const FlaggedRoute = observer(({ flagKey, redirectTo = '/' }: FlaggedRouteProps) => {
  const { FeatureFlagStore } = useStore();
  const isEnabled = useFlag(flagKey);

  if (!FeatureFlagStore.isLoaded) {
    return null;
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
});

export default FlaggedRoute;
